exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-vehicle-outer-container[data-v-5636caba]{width:50%;margin:auto}.sc-vehicle-reg-cart-info[data-v-5636caba]{text-align:left;font-size:18px;font-weight:600}@media (max-width:768px){.sc-vehicle-outer-container[data-v-5636caba]{width:100%}.sc-vehicle-outer-container .page-title[data-v-5636caba]{margin:15px 0}}", ""]);

// exports
